import { makeService } from './api';

const service = makeService('pages');

export default service;